import type { ComponentProps } from 'react'
import { Controller } from 'react-hook-form'
import { IonInput } from '../styled'

type TextInputProps = {
  name: string
  capitalize?: boolean
} & Omit<ComponentProps<typeof IonInput>, '$invalid'>

export function TextInput({
  label,
  name,
  type,
  children,
  capitalize = false,
  ...inputProps
}: TextInputProps) {
  const handleInputChange = (value: string) => {
    const result = value.trimStart()

    return result.length
      ? result.charAt(0).toUpperCase() + result.slice(1)
      : result
  }

  return (
    <Controller
      name={name}
      defaultValue=''
      render={({
        field: { onChange, value },
        fieldState: { error, invalid },
      }) => (
        <IonInput
          className={invalid ? 'ion-invalid ion-touched' : ''}
          onIonInput={(e) => {
            const value = e.detail.value || ''
            onChange(capitalize ? handleInputChange(value) : value)
          }}
          value={value}
          name={name}
          label={label}
          type={type}
          errorText={error?.message || 'Обязательное поле'}
          {...inputProps}
          labelPlacement='floating'
          fill='outline'
          mode='md'
        >
          {children}
        </IonInput>
      )}
    />
  )
}
